import React, { useState, useEffect } from 'react';
import './quote.scss';
import QuoteDetail from './QuoteDetail';
import { useIsMobile } from '../../functions/Theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faPlus, faMinus, faX } from '@fortawesome/free-solid-svg-icons';
import { GetLogo } from '../../components/quote/Logos';
import { decodeLineBreak } from '../../functions/HTMLDecode';
import { IsProductDetailsEnabled } from '../../functions/Configuration'

export default function Quote(props: any) {
    const [quote, setQuote] = useState<any>(props.quote);
    const [pounds, pence] = parseFloat(quote.annualPremium.toString()).toFixed(2).split('.');
    const isMobile = useIsMobile();
    const productDetailsEnabled = IsProductDetailsEnabled();

    function setDetailsDisplay(state: boolean) {
        quote.showDetails = state;
        setQuote(quote);
        props.updateQuoteList();
    }

    const renderSchemeInfo = (quote: any) => {
        const productDetails = quote.quote.productDetailsField;
        if (!productDetailsEnabled || !productDetails) {
            return null;
        }
        return productDetails.map((detail: string, index: number) => {
            //Regex to store everything before the hyphen into match[1] and after hyphen into match[2].
            //If no hyphen present then everything is inserted into match[1]
            const match = detail.match(/^([^:-]+?)(?:\s*-\s*(.+))?$/);
            const label = match?.[1];
            const data = match?.[2];

            return (
                <div className="scheme-info-row">
                    <span>{label}</span>{data && <> - <strong>{data}</strong></>}
                </div>
            );
        });
    };

    const columnSpan = () => {
        var premCoversAmount = props.quote.premCovers.length;
        if (premCoversAmount == 1)
            return 4; //InsurerName + Price + Buy Button + PremiumCover
        else
            return 5; //Maximum 2 PremiumCovers in summary
    }

    const formatCoverValue = (value: string) => decodeLineBreak(value.replace(/\.00$/, ''));

    return (
        <>
            <tr className="quote-row">
                <td data-label="Insurer">
                    <div className="insurer-cell">
                        {GetLogo(props.quote.schemeName, props.quote.insurerId, props.quote.insurerName, false)}
                        {!isMobile && renderSchemeInfo(quote) &&
                            <div className="scheme-info">{renderSchemeInfo(quote)}</div>
                        }
                    </div>
                </td>

                {!isMobile && <>
                    {props.quote.premCovers[0]?.coverValue &&
                        <td>
                            <div className="annual-total">
                                {formatCoverValue(props.quote.premCovers[0].coverValue)}

                            </div>
                        </td>
                    }
                    {props.quote.premCovers[1]?.coverValue &&
                        <td>
                            <div className="annual-total">
                                {formatCoverValue(props.quote.premCovers[1].coverValue)}

                            </div>
                        </td>
                    }
                </>}

                <td data-label="Price" className={!props.payAnnual ? "price-cell-monthly" : "price-cell-annually"}>
                    {props.payAnnual &&
                        <div className="annual-total">
                            {!isMobile && <span className="total-label">TOTAL<br></br></span>}
                            &pound;{pounds}<sub className="decimals-sup">.{pence}</sub><br></br>
                            {isMobile && <span className="annually-label"> annually</span>}
                        </div>
                    }
                    {!props.payAnnual &&
                        <>
                            <dl className='monthly-row'>
                                <dt className='monthly-label'>1 x</dt>
                                <dd className='monthly-data'>&pound;{parseFloat(quote.monthlyFirstInstalment.toString()).toFixed(2)}</dd>
                            </dl>
                            <dl className='monthly-row'>
                                <dt className='monthly-label'>{quote.monthlyPaymentsCount} x</dt>
                                <dd className='monthly-data'>&pound;{parseFloat(quote.monthlyPayment.toString()).toFixed(2)}</dd>
                            </dl>
                            <dl className='monthly-row'>
                                <dt className='monthly-label'>Total</dt>
                                <dd className='monthly-data'>&pound;{parseFloat(quote.totalDebt.toString()).toFixed(2)}</dd>
                            </dl>
                        </>
                    }
                </td>

                {isMobile && props.quote.premCovers[0].coverName != null && (<>
                    <table className="cover-tbl">
                        <tbody>
                            {props.quote.premCovers[0]?.coverValue &&
                                <tr>
                                    <td className="cover-desc">{props.quote.premCovers[0].coverName} Cover</td>
                                    <td className="cover-amount">
                                        {formatCoverValue(props.quote.premCovers[0].coverValue)}
                                    </td>
                                </tr>
                            }
                            {props.quote.premCovers[1]?.coverValue &&
                                <tr>
                                    <td className="cover-desc">{props.quote.premCovers[1].coverName} Cover</td>
                                    <td className="cover-amount">
                                        {formatCoverValue(props.quote.premCovers[1].coverValue)}
                                    </td>
                                </tr>
                            }
                            {renderSchemeInfo(quote) && (
                                <tr>
                                    <td colSpan={2} className="scheme-info-mobile-cell">
                                        <div className="scheme-info">
                                            {renderSchemeInfo(quote)}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                </>)}

                <td data-label="" className="quote-actions">
                    <button className="buy-btn" onClick={() => props.buyCover(quote)}>{isMobile ? (<>Buy Cover <FontAwesomeIcon icon={faChevronRight} /></>
                    ) : (
                        <>Buy <FontAwesomeIcon icon={faChevronRight} /></>
                    )}</button><br></br>
                    {!quote.showDetails &&
                        <span className="details" onClick={() => setDetailsDisplay(true)}>More details <FontAwesomeIcon icon={faPlus} /></span>
                    }
                    {quote.showDetails &&
                        <span className="details" onClick={() => setDetailsDisplay(false)}>More details <FontAwesomeIcon icon={faX} /></span>
                    }
                </td>
            </tr>
            <tr className="quote-sub">
                <td colSpan={columnSpan()} className="quote-sub-cell">
                    {quote.showDetails &&
                        <QuoteDetail quote={quote} payAnnual={props.payAnnual} policyNumber={props.policyNumber} />
                    }


                    <div className="underwritten">Underwritten by {quote.insurerName}. Includes IPT
                        {quote.adminFeeSpecified &&
                            <>{!props.payAnnual && <>, 16% interest charge</>} and an administration charge of &pound;{quote.adminFee}</>
                        }
                        .
                    </div>
                </td>
            </tr>
        </>
    )
}